var _g, _mask, _g2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBonusCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 12,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 4.4H7V.5a.5.5 0 0 0-.4-.5H4.9c-.3 0-.5.2-.5.5v3.9H.5c-.3 0-.5.2-.5.5v1.7c0 .3.2.5.5.5h3.9V11c0 .3.2.5.5.5h1.7c.3 0 .5-.2.5-.5V7h3.8c.4 0 .5-.2.5-.5V4.9a.5.5 0 0 0-.5-.5z",
    fill: "#ffd420"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 8.5c0 .8-.6 1.4-1.3 1.4a1.3 1.3 0 0 1-1.3-1.4V6.6c0-.7.5-1.3 1.3-1.3A1.3 1.3 0 0 1 18 6.6v2zm2 0V6.6a3 3 0 0 0-3-3.2c-.8 0-1.3.4-1.5.4l-.1-.2V.5l-.2-.2h-1.7c-.1 0-.2 0-.2.2v11c0 .2 0 .3.2.3H15c.3 0 .2-.4.3-.4.3 0 .7.4 1.5.4 1.9 0 3.3-1.3 3.3-3.3zm5.4.2c0 .8-.6 1.3-1.3 1.3-.8 0-1.3-.5-1.3-1.3V6.5c0-.8.5-1.3 1.3-1.3.7 0 1.3.5 1.3 1.3v2.2zm2 0V6.5c0-2-1.3-3.2-3.3-3.2-2 0-3.4 1.2-3.4 3.2v2.2c0 2 1.3 3.2 3.4 3.2 2 0 3.4-1.2 3.4-3.2zm7.6 3h-1.8l-.1-.1v-5a1.3 1.3 0 0 0-1.3-1.3c-.8 0-1.3.6-1.3 1.3v5c0 .1 0 .2-.2.2h-1.7c-.1 0-.2 0-.2-.2v-8c0-.1 0-.2.2-.2H30c.3 0 .2.4.3.4.3 0 .7-.4 1.5-.4 1.9 0 3.3 1.3 3.3 3.2v5l-.2.2zm7.7 0h-1.5c-.3 0-.2-.3-.3-.3-.2 0-.7.4-1.5.4a3.1 3.1 0 0 1-3.2-3.3V3.6l.1-.2h1.8a.2.2 0 0 1 .2.2v5c0 .7.5 1.3 1.2 1.3a1.3 1.3 0 0 0 1.3-1.4V3.6l.2-.2h1.7c.1 0 .2 0 .2.2v8c0 .1 0 .2-.2.2zM49.5 4c.7.5 1.1 1.2 1.1 1.5v.1l-1.6.7h-.2c-.4-.6-.6-1-1.3-1h-.6c-.6 0-1 .1-1 .6 0 .7 1 .6 2.5 1s2.2 1 2.2 2.3c0 1.7-1.2 2.8-3.1 2.8h-.6c-1 0-1.8-.2-2.3-.8-.6-.6-.8-1.1-.8-1.3l.1-.1 1.5-.8c.1 0 .2 0 .2.2.4.6.6 1 1.3 1h.6c.6 0 1-.3 1-.8 0-.7-1-.6-2.5-1-1.4-.3-2.1-1-2.1-2.2 0-1.7 1.2-2.8 3-2.8h.6c.8 0 1.5.2 2 .6z",
    fill: "#8cc63f"
  }))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "a",
    maskUnits: "userSpaceOnUse",
    x: 53,
    y: 3,
    width: 7,
    height: 9
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M53.3 3.3H60V12h-6.7V3.3z",
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m59.8 9.7-1.5-.8h-.1l-.3.3c-.3.6-.6.9-1.2.9a1.3 1.3 0 0 1-1.3-1.3V6.5a1.3 1.3 0 0 1 1.3-1.3c.6 0 1 .3 1.2.9l.3.3 1.6-.8.2-.2c0-.2-.5-1-1.2-1.5-.6-.4-1.2-.6-2-.6-2.1 0-3.5 1.3-3.5 3.2v2.3c0 2 1.4 3.2 3.4 3.2 1 0 1.8-.3 2.4-.8.6-.7.9-1.2.9-1.4l-.2-.1z",
    fill: "#8cc63f"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67 11.6V6.5c0-2-1.3-3.2-3.3-3.2-1 0-1.8.3-2.3.8-.7.6-1 1.2-1 1.3l.2.1 1.5.8h.1l.5-.5c.2-.4.6-.6 1-.6.7 0 1.2.5 1.3 1.2v.2c0 .2 0 .2-.2.2h-1.7c-1.5 0-2.6 1-2.6 2.5s1 2.5 2.6 2.5h.7c.6 0 1-.3 1.2-.3.2 0 0 .3.3.3H67c.1 0 .2 0 .2-.2zm-2-3v.3c-.3.7-.7 1-1.2 1H63c-.3 0-.5-.2-.5-.5V9c0-.3.2-.5.5-.5H65zm7.8-3V3.8c0-.2-.3-.3-1-.3-.5 0-.9.2-1.4.5l-.2-.1v-.3l-.2-.1h-1.6l-.1.2v8l.1.1h1.7c.2 0 .2 0 .2-.2v-5c0-.6.6-1.2 1.3-1.2.5 0 .9.4 1.1.4l.1-.2zm7.2 6V.6a.2.2 0 0 0-.2-.2h-1.7l-.2.1v3.1l-.1.2c-.2 0-.7-.3-1.5-.3a3.1 3.1 0 0 0-3 3.2v1.9c0 2 1.3 3.2 3.2 3.2.8 0 1.2-.3 1.5-.3.1 0 0 .3.3.3h1.5c.1 0 .2 0 .2-.2zm-2-3c0 .7-.6 1.3-1.4 1.3a1.3 1.3 0 0 1-1.3-1.3v-2c0-.6.6-1.2 1.3-1.2A1.3 1.3 0 0 1 78 6.7v1.9z",
    fillRule: "evenodd",
    fill: "#8cc63f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBonusCard);
export default __webpack_public_path__ + "static/media/bonus-card.29bfc7e1ae53b2812d010458854b299c.svg";
export { ForwardRef as ReactComponent };